module.exports = Object.freeze({
  BASE_URL: "https://rpapi.infomate360.com/api/v1/",
  // BASE_URL: "http://localhost:5000/api/v1/",
});
